module.exports = __webpack_public_path__ + "static/media/basketball-resized.42364a10.jpg";